<div class="multi-select-container">
  <mat-form-field class="select-search">
    <input matInput type="text" [placeholder]="'app.general.search' | translate" [value]="search()" (input)="setSearch($event)" />
    <span matSuffix>
      @if(!search()) {
        <img width="24" height="24" ngSrc="../../../../assets/icons/search-filter.svg" [alt]="'app.imgAlt.search' | translate" />
      } @else {
        <button class="transparent" type="button" (click)="search.set('')">
          <img width="24" height="24" ngSrc="../../../../assets/icons/icon-close.svg" [alt]="'app.imgAlt.close' | translate" />
        </button>
      }
    </span>
  </mat-form-field>

  <div class="multi-select-list">

    <div class="counter-row">
      <div class="counter">{{'app.general.selected' | translate }}: {{selected().size}}</div>
      <app-general-button
        [buttonStyle]="'inline'"
        [buttonHeight]="24"
        [buttonName]="'app.general.clearSelection'"
        (buttonClicked)="resetFilter.emit()"
      />
    </div>

    <button
      type="button"
      class="multi-select-item checkbox-button select-all"
      (click)="toggleSelectAll()"
    >
      <mat-checkbox
        class="general-checkbox"
        disableRipple
        [checked]="allSelected()"
        [indeterminate]="someSelected()"
      />
      <span class="multi-select-name">
      {{ allSelected()
        ? ('app.general.deselectAll' | translate)
        : ('app.general.selectAll' | translate) }}
    </span>
    </button>

    <div class="scroll-y">
      @for (item of filteredList(); track item.id) {
        <button type="button" class="multi-select-item checkbox-button" (click)="toggleSelection(item)">
          <mat-checkbox class="general-checkbox" disableRipple [checked]="selected().has(item.id)" />
          <span class="multi-select-name">{{ item.name | translate }}</span>
        </button>
      }
    </div>
  </div>
</div>
